export default function Footer() {
  const footerLinks = {
    观影导航: [
      { label: '最新电影', href: '#cards' },
      { label: '热播榜单', href: '#ranking' },
      { label: '专题合集', href: '#index' },
      { label: '精彩预告', href: '#media' },
      { label: '热门话题', href: '#topics' },
    ],
    服务支持: [
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '关于我们', href: '#about' },
      { label: '平台优势', href: '#features' },
      { label: 'APP下载', href: '#app' },
    ],
  };

  const partnerNames = [
    '光影伙伴', '银幕联盟', '视界传媒', '星辉影业',
    '华语精选', '映画工场', '云端剧场', '极清视界',
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16 max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-12 gap-8 md:gap-10">
            <div className="col-span-2 md:col-span-4">
              <a href="#hero" className="inline-flex items-center gap-2 mb-4 whitespace-nowrap">
                <span className="font-heading text-2xl font-bold text-white">
                  <i className="ri-movie-2-line mr-1"></i>麻花影院
                </span>
              </a>
              <p className="text-foreground-400 text-sm leading-relaxed max-w-xs">
                麻花影院致力于为影迷提供高清超清4K画质影视在线观看体验，海量高清电影、蓝光画质大片流畅不缓冲，追求极致清晰观影享受。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title} className="col-span-1 md:col-span-2">
                <h4 className="text-white font-heading text-sm font-semibold mb-4">{title}</h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-foreground-400 hover:text-accent-400 text-sm transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="col-span-2 md:col-span-4">
              <h4 className="text-white font-heading text-sm font-semibold mb-4">合作伙伴</h4>
              <div className="grid grid-cols-2 gap-2">
                {partnerNames.map((name) => (
                  <span
                    key={name}
                    className="text-foreground-500 text-xs py-1.5 px-3 bg-background-800/60 rounded-md whitespace-nowrap"
                  >
                    {name}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-foreground-500 text-xs">
                &copy; {new Date().getFullYear()} 麻花影院 mahuayingyuan.com 版权所有
              </p>
              <p className="text-foreground-600 text-xs">
                本站内容仅供影迷交流参考，不存储任何视频文件
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}